module.exports = __webpack_public_path__ + "img/工业互联网.eeb3ee7b.jpg";